import { VerticalSpacingElementModel } from '@/services/platform/api/model';
import type { CSSProperties } from 'react';
import { cn, ModuleProperties } from '@/lib/core';
import ModuleWrapper from '@/components/shared/module/wrapper';

export const VerticalSpacing = (props: ModuleProperties) => {
  const content = props.content as VerticalSpacingElementModel | undefined;

  if (!content) return null;

  const { desktopHeight = 0, tabletHeight = 0, mobileHeight = 0 } = content.properties ?? {};
  const spacingStyle = {
    ['--vs-mobile' as string]: `${mobileHeight}px`,
    ['--vs-tablet' as string]: `${tabletHeight}px`,
    ['--vs-desktop' as string]: `${desktopHeight}px`,
  } as CSSProperties;

  return (
    <ModuleWrapper
      component={props}
      classNames={{
        base: cn(['module__vertical-spacing']),
      }}
      isFullWidth={true}
      {...props}
    >
      <div key={props.index} className="col-span-2 lg:col-span-12">
        <div
          aria-hidden="true"
          className="h-(--vs-mobile) w-full sm:h-(--vs-tablet) lg:h-(--vs-desktop)"
          style={spacingStyle}
        />
      </div>
    </ModuleWrapper>
  );
};
